export default __webpack_public_path__ + "static/blob8-3cbecfde428735ffc999d9321a85f1a0.svg";